import { makeStyles } from "@material-ui/core";

const useOptimizationStyles = makeStyles(theme => ({
    button: {
        margin: 5,
        '&.Mui-disabled': {
            backgroundColor: "rgba(25,118,210, 0.7)",
            color:"#fff"
        },
    },
    buttonLabel: {
        fontFamily: "OpenSans",
        fontWeight: 400,
        fontSize: "0.92rem"
    }
}));

export default useOptimizationStyles;